module.exports = __webpack_public_path__ + "img/rishelje.bd289d28.jpg";